// 工作计划
import Layout from '@/layout'


const workPlanRoute = [
    {
        path: '/workPlan',
        component: Layout,
        redirect: '/workPlan/workPlan',
        name: 'workPlan',
        alwaysShow: true,
        meta: {
          title: '工作计划',
          icon: 'jihua',
          roles: ['ROLE_STAFF']
        },
        children: [
          {
            path: 'workPlan',
            name: 'checkWorkPlan',
            component: () => import('@/views/work/workPlan'),
            meta: {
              title: '工作计划【查看】',
              icon: 'jihua'
            }
          },
          {
            path: 'addPlan',
            name: 'addPlan',
            component: () => import('@/views/work/addPlan'),
            meta: {
              title: '工作计划【申请】',
              icon: 'form'
            },
          },
          {
            path: "work-center",
            component: () => import("@/views/taskCenter/workCenter/index"),
            name: "workCenter",
            meta: {
              title: "工作计划【审批】",
              icon: "check-result",
            },
          },
          {
            path: 'editPlan',
            name: 'editPlan',
            component: () => import('@/views/work/addPlan'),
            meta: {
              title: '编辑-工作计划',
              icon: 'form'
            },
            hidden: true
          },
          {
            path: 'processWorkPlan',
            name: 'processWorkPlan',
            component: () => import('@/views/work/addPlan'),
            meta: {
              title: '审核-工作计划',
              icon: 'form'
            },
            hidden: true
          },
          {
            path: 'viewWorkPlan',
            name: 'viewWorkPlan',
            component: () => import('@/views/work/addPlan'),
            meta: {
              title: '查看-工作计划',
              icon: 'form'
            },
            hidden: true
          }
        ]
      }
];

export default workPlanRoute


// WEBPACK FOOTER //
// ./src/router/modules/workPlan.js